import React from 'react';

function Disclaimer() {
  return (
    <section className='section text-center'>
        <h1>Disclaimer & Copyright</h1>
        <h2>Disclaimer</h2>
        <p>
        The information provided on the JSProperty website is for general informational purposes only. While we strive to ensure that all content is accurate and up to date, JSProperty makes no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of any information, products, services, or related graphics contained on the website for any purpose.
        <br />
        <br />
        Any reliance you place on such information is strictly at your own risk. JSProperty shall not be liable for any loss or damage, including without limitation, indirect or consequential loss or damage, arising from loss of data or profits arising out of, or in connection with, the use of this website.
        <br />
        <br />
        Through this website, you may be able to link to other websites that are not under the control of JSProperty. We have no control over the nature, content, and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.
        </p>
        <h2>Copyright</h2>
        <p>
        All content, design, text, graphics, logos, images, and other materials on this website are the intellectual property of JSProperty unless otherwise stated. They are protected by copyright and other intellectual property laws.
        <br />
        <br />
        You may view, download, and print pages from this website for your personal use only. Any other use, including reproduction, modification, distribution, or republication, without the prior written consent of JSProperty, is strictly prohibited.
        </p>
    </section>

  );
}

export default Disclaimer;